import { post } from '../index'

export default {
  login: (authorization, data) => post('token', data, { headers: { Authorization: authorization } })
}
